import { useEffect } from "react";
import { supabase } from "../../lib/supabase";

/**
 * Maneja el callback de OAuth (Google).
 * Supabase redirige aquí con el token en el hash.
 * Este componente solo necesita existir — supabase-js
 * procesa el hash automáticamente en onAuthStateChange.
 */
export default function AuthCallback() {
  useEffect(() => {
    // supabase-js detecta el hash y actualiza la sesión automáticamente
    // Solo verificamos que la sesión se haya establecido
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        // Redirigir al home después de un breve delay
        window.location.replace("/");
      }
    });
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Outfit', sans-serif",
        color: "#6B7280",
      }}
    >
      Autenticando...
    </div>
  );
}
